import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/fp/map';
import pipe from 'lodash/fp/pipe';

import MarketplaceContext from '@nerdwallet/structured-content/contexts/MarketplaceContext';
import { getDateMostRecent } from '@nerdwallet/wp-api/utils/date';
import { getDateLastIngestedAt } from '@nerdwallet/marketplace/selectors/common';

import { stringTextAreaSpec } from '../../lib/editing-configs';
import Paragraph from '../paragraph/paragraph';

const LastUpdate = ({ text }) => {
  const { entities: marketplaceEntities = [] } = useContext(MarketplaceContext);
  const date =
    pipe(map(getDateLastIngestedAt), getDateMostRecent)(marketplaceEntities) ||
    '--';

  return (
    <Paragraph
      body={text}
      interpolateFrom={{ date }}
      dangerouslyAllowHTMLIn={{ body: true }}
    />
  );
};

LastUpdate.propTypes = {
  text: PropTypes.string,
};

LastUpdate.defaultProps = {
  text: 'Updated #{date}.',
};

LastUpdate.getEditingConfig = () => [
  stringTextAreaSpec('text', 'Last Update text template [optional]', {
    help: 'Defaults to: Updated #{date}.',
  }),
];

export default LastUpdate;
